import React, { useRef, useState, useEffect } from 'react';
import { uploadFile,serviceFetchFailedLogs, getHistory }from "../Services/Service";
import { CustomLoader, CustomLoading } from "../Services/CommonLibrary"
import History from './History';
import { color } from 'highcharts';
import { ModalBox } from "../Services/CommonLibrary"

function FileUploadTabNew({ onReload }) {
    const [loading, setLoading] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [intervalPopup, setIntervalPopup] = useState(false);
    const [uidStore, setUidStore] = useState('');
    const [viewData, setViewData] = useState([]);
    const [file, setFile] = useState(''); // storing the uploaded file    
    // storing the recived file from backend
    const [data, getFile] = useState({ name: "", path: "" });
    const [showModal, setShowModal] = useState(false);
    const [modalClass, setModalClass] = useState('md');
    const [modalBody, setModalBody] = useState('');
    const handleClose = () =>{  setShowModal(false);}
    const [intervalId, setIntervalId] = useState(null);
    const [count, setCount] = useState(0);
    const [fileUrl, setFileUrl] = useState('');
    const buttonRef = useRef(null);

    const [alertInfo, setAlertInfo] = useState({
        xlsxErr : false,
        allfileErr : false,
        drnotesErr : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,xlvisible,allvisible,drnotevisible,clas)=>{
    setAlertInfo({...alertInfo, ['xlsxErr']: xlvisible,['allfileErr']:allvisible,['drnotesErr']:drnotevisible,['cls']:clas,['msg']: msg});
    }

    useEffect(() => {
        if (uidStore) {
          const id = setInterval(() => {
            fetchLiveUploadedData(uidStore);
          }, 10000);
          setIntervalId(id);
        }

        if (!uidStore) {
            clearInterval(intervalId);
            setIntervalId(null);
        }

        return () => clearInterval(intervalId);
      }, [uidStore]);

    useEffect(() => {
        
        fetchHistoryList();
    }, []);

      const handleReloadClick = () => {
        //onReload();
      };
    

    const fetchHistoryList = async () => {
        getHistory()
            .then((res) => {
                setFileUrl(res.data.fileUrl)
            }
        );
    }

    // const el = useRef(); // accesing input element
    const handleChange = (e) => {
        const MAX_FILE_SIZE = 1024*30;
        
        const file = e.target.files[0]; // accesing file
        const fileSizeKiloBytes = file.size / 1024;

        if(fileSizeKiloBytes > MAX_FILE_SIZE){
            // setErrorMsg("File size is less than minimum limit");
            // setIsSuccess(false)
            alert("File size should be less than 30 MB");
            document.getElementById(e.target.id).value = "";
            return
          }

        setFile(file); // storing file
        

        
        
        // console.log(file);  
    }
    const uploadFile_Html = async (e) => {
        
        
        if(file!=''){
            setLoading(true);
                const formData = new FormData();
                formData.append('file', file); // appending file
                formData.append('type', e.target.id); // appending file

                let xlsxVis=false, allfileVis=false, drnotesVis=false;

                if(e.target.id=="xlsxSubmit"){
                    formData.append('uploadtype', 'marketing_account_creation'); // appending file
                    xlsxVis=true;
                }

                uploadFile(formData).then((response) => {

                    
                    setModalTitle('');
                    setModalBody('');
                    setIntervalPopup(false);
                    setLoading(false);
                    setUidStore('');

                    if(typeof(response)!=='undefined' && e.target.id=="xlsxSubmit"){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        let uploadStatus = response.data.status;
                        if(uploadStatus == 3){
                            setModalClass('xl')
                            setShowModal(true)
                            // console.log(response.data.data.message);                           
                            const modalBodyComponent= response.data.data.message.length > 0 ? response.data.data.message.map((data, i) => (
                                <tr key={i}>
                                    <td><span style={data[8]=='Success' ? {color:"green"} : {color:"red"}}>{data[8] == 'Success' ? 'Valid Data' : 'Invalid Data'}</span></td>
                                    <td >
                                        <span style={data[8]=='Success' ? {color:"green"} : {color:"red"}}>
                                            {/* {data[8] == 'Success' ? 'Valid Data' : 
                                                data[8].split(',').map((item, index) => {
                                                    return (index === 0) ? item : [<br key={index} />, item];
                                                })
                                            } */}

                                        {(data[8] && data[8] !== 'Success') || (data[10] && data[10] !== 'Success') ? 
                                                    (data[8] && data[8] !== 'Success' ? data[8] : data[10])
                                                        .split(',')
                                                        .map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                {index > 0 && <br />}
                                                                {item}
                                                            </React.Fragment>
                                                        ))
                                                    : 'Valid Data'
                                                }
                                        </span>
                                    </td>
                                    <td>{data[0]}</td>
                                    <td>{data[1]}</td>
                                    <td>{data[2]}</td>
                                    <td>{data[3]}</td>
                                    <td>{data[4]}</td>
                                    <td>{data[5]}</td>
                                    <td>{data[6]}</td>
                                    <td>{data[7]}</td>
                                </tr>
                            )) : <tr><td colSpan="2">No Records</td></tr>;
                            const html = <div className="table-responsive"><table className="table"><thead><tr> <th scope='col'>Status</th>
                            <th scope='col'>Reason</th>
                            <th scope='col'>Practice Name</th>
                            <th scope='col'>Doctor email</th>
                            <th scope='col'>NHS number</th>
                            <th scope='col'>Patient Name</th>
                            <th scope='col'>Patient Email</th>
                            <th scope='col'>Patient Mobile</th>
                            <th scope='col'>Program Name</th>
                            <th scope='col'>Division</th></tr></thead><tbody>{modalBodyComponent}</tbody></table></div>
                            setModalBody(html);
                            setModalTitle(<span style={{"backgroundColor": "#e3b6b6",padding: "5px",borderRadius: "10px"}}> 0 Accounts Created. Please Resolve Below Errors And Upload File Again.</span>)
                            handleReloadClick();
                        }else if(uploadStatus == 1){
                            setUidStore(response.data.uid);
                            setModalClass('md')
                            setShowModal(true);
                            setModalTitle('Alert')
                            setModalBody(<span>File Uploaded Successfully, Updating Patient Data... </span>);
                            setIntervalPopup(true);

                            const timeoutId = setTimeout(() => {
                                setShowModal(false);
                                fetchLiveUploadedData(response.data.uid);
                                setModalClass('xl')
                                setShowModal(true);
                                setIntervalPopup(true);
                                // console.log(response.data.uid);
                                setModalTitle('Status: Uploaded File. Updating Patient Data...')
                              }, 3000);
                              handleReloadClick();
                            
                        }else if(uploadStatus == 4){
                            setModalClass('md')
                            setShowModal(true);
                            setModalTitle('Alert!');
                            setModalBody(response.data.data.message);
                        }
                        setFile('');
                        // onShowAlert(response.data.data.message,xlsxVis,allfileVis,drnotesVis,clas);    
                        
                    }
                    
                    document.getElementById("xlsxFile_new").value = "";
                }
            );
        }else{
            alert('Please select file');
        }
    }
 
    // const appendInsertData = (uidData) => {
    //     setShowModal(true)
    //     console.log(showModal)

    //         const id = setInterval(() => {
    //             fetchLiveUploadedData(uidStore)
    //                 console.log('Calling API...');
    //             }, 5000);
    //         setIntervalId(id);
    // }
    const viewPopup=(callId)=>{      
        // fetchLiveUploadedData(callId);
        setModalClass('xl');
        setShowModal(true);
        // setIntervalPopup(true);
    }


    const fetchLiveUploadedData = (uidStore) => {
        serviceFetchFailedLogs(uidStore,'upload_summary')
                    .then((res) => {
                        setFileUrl(res.data.fileUrl);
                        if(res.data.data[0].queueStatus == 2) {onReload(); setUidStore('');clearInterval(intervalId);}
                        buttonRef.current.click();
                        const modalBodyComponent= res.data.data.length > 0 ? 
                            res.data.data.map((item,i) => 
                                                        <tr key={i}>
                                                                <td>
                                                                    <span style={item.status=='Success' ? {color:"green"} : {color:"red"}}>
                                                                        {item.status=='Success'?"Data Updated":"Invalid Data"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span style={item.statusMsg=='Success' ? {color:"green"} : {color:"red"}}>{item.status=='Success'?"Data Updated":item.statusMsg}</span>
                                                                </td>
                                                            { item.rawJson.map((data,i) =>
                                                                <td key={i}>{data}</td>
                                                                )}
                                                    </tr>
                            ) : 
                            <tr><td colSpan="2">No Records</td></tr>;

                        const html = <><div className="table-responsive"><table className="table"><thead><tr><th scope="col">Status</th><th scope="col">Reason</th>
                        <th scope='col'>Practice Name</th>
                        <th scope='col'>Doctor email</th>
                        <th scope='col'>NHS number</th>
                        <th scope='col'>Patient Name</th>
                        <th scope='col'>Patient Email</th>
                        <th scope='col'>Patient Mobile</th>
                        <th scope='col'>Program Name</th>
                        <th scope='col'>Division</th>
                       </tr></thead><tbody>{modalBodyComponent}</tbody></table></div>{res.data.data[0].queueStatus != 2 ?<CustomLoading /> : null}</>
                        setModalBody(html);
                        
                        }
                    );
    }

    
    return (
        <>
            <section className='profile-box1'>
                 
                <div className='row'>
                    <h1 className='title mb-4'>Upload Consented Patients Data</h1>
                    <div className="file-upload">
                        <div className="row ">

                            <div className="col-md-5 col-xl-4">
                                <input type="file" id="xlsxFile_new" className="btn-upload" accept=".xls, .xlsx, application/excel,application/vnd.msexcel, application/vnd. ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" required="required" onChange={handleChange} />

                                <span>Allowed file type :- .xlsx</span><br></br>
                                <span>Max File size :- 30 MB</span>
                                {alertInfo.xlsxErr ? 
                                    <div className={"text-"+ alertInfo.cls +" form-floating mb-3"} role="alert">
                                        {alertInfo.msg}
                                    </div> : null}
                            </div>

                            <div className="col-md-7 col-xl-6">
                                <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="xlsxSubmit">
                                Upload Data                                
                            </button>
                            </div>
                            
                            {/* <div className="col-md-12"><a href={fileUrl} target="_blank"><span>Download Sample</span></a></div> */}
                            {uidStore ? 
                                    <div>
                                        <button className='btn btn-success btn-sm btn-edit' onClick={(e)=>viewPopup(uidStore)}>Upload in progress.. check status</button>
                                    </div> : null}
                                    <button ref={buttonRef} style={{display: 'none'}}  onClick={(e)=>handleReloadClick()}>Hidden Button</button>
                        </div>
                        {/* <hr className='line' /> */} 
                        
                    </div>

                </div>


                
                
            </section>
            
            { loading ? <CustomLoader /> : null }


            
            {/* {showModal?
                <>
                
                <Modal dialogClassName="modal-xl" show={showModal} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>View History</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                  <div className='table-responsive mt-2'>
                    <MDBTable align='middle'>
                            <MDBTableHead>
                                <tr className="table-head">
                                    <th scope='col'>Practice Email</th>
                                    <th scope='col'>Doctor email</th>
                                    <th scope='col'>NHS number</th>
                                    <th scope='col'>Patient Name</th>
                                    <th scope='col'>Patient Email</th>
                                    <th scope='col'>Patient Mobile</th>
                                    <th scope='col'>Program Name</th>
                                    <th scope='col'>Division</th>
                                    <th scope='col'>Remark</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                {
                                
                                viewData.length>0 ?
                                viewData.map((data, i) => (
                                        <tr key={i}>
                                            <td>{data[0]}</td>
                                            <td>{data[1]}</td>
                                            <td>{data[2]}</td>
                                            <td>{data[3]}</td>
                                            <td>{data[4]}</td>
                                            <td>{data[5]}</td>
                                            <td>{data[6]}</td>
                                            <td>{data[7]}</td>
                                            <td ><span style={data[8]=='Success' ? {color:"green !important"} : {color:"red !important"}}>{data[8]}</span></td>
                                        </tr>
                                    ))
                                    :
                                    <tr key="1">
                                        <td colSpan="8" style={{textAlign:"center"}}>No Records</td>                                    
                                    </tr>
                                }

                            </MDBTableBody>
                        </MDBTable>
                </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </>
            :null
            } */}
        {showModal?<ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody} type={modalClass} />:null}

        </>
    );
}
export default FileUploadTabNew;